import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';

// Rename the name of the function:
const EmailTemplateList: React.FC = () => {

    // Filter the list on the division selected in the settings menu
    const { selectedDivision, isEnvironmentSelected } = useSettingsDivision();
    const divisionParams = !isEnvironmentSelected && selectedDivision ? { 'division_scope': selectedDivision.id } : {};

    // Specify the options of this list:
    const query = {
        endpoint: 'get_email_template_list',
        defaultParams: { 'deleted': false, ...divisionParams },
        object: 'email_template'
    }
    const groupByField = {
        field: 'connected_feature',
        translateValue: true
    }
    const objectName = 'email.email_template.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deleted'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const openPageUrl = 'settings/features/email/template-library';
    const onRowClick = 'detailPage'
    const detailPageUrl = 'settings/features/email/template';

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'name', label: 'email.email_template.name_label' },
    ];

    return (
        <AbstractList
            key={!isEnvironmentSelected && selectedDivision ? selectedDivision.id : 'environment'}
            query={query}
            objectName={objectName}
            columns={columns}
            groupByField={groupByField}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            openPageUrl={openPageUrl}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
            detailPageUrl={detailPageUrl}
        />
    );
};

export default EmailTemplateList;